import MicroModal from 'micromodal';

const modal = {
  modalNodes: null,

  init() {
    this.modalNodes = document.querySelectorAll('[data-modal-id]');

    if(this.modalNodes) {
      Array.from(this.modalNodes).forEach(el => el.addEventListener('click', (e) => this.handleBtnClick(e), false));
    }
  },

  changeVideoSrc(src, modal) {
    const iframe = modal.querySelector('iframe');
    if(iframe) {
      iframe.src = src;
    }
  },

  handleBtnClick({ target }) {
    if (document.querySelector(`#${target.dataset.modalId}`)) {
      const config = {};
      if (target.dataset.modalVideo !== undefined) {
        config.onShow = (modal) => this.changeVideoSrc(target.dataset.modalVideo, modal);
        config.onClose = (modal) => this.changeVideoSrc('', modal);
      }

      MicroModal.show(target.dataset.modalId, config);
    }
  },
};

export default modal;



// WEBPACK FOOTER //
// ./scripts/modules/modal.js